// S2-FE2: Logo
// Inline SVG logomark — Stacked Bars. No external CSS file.

export interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

const sizeMap: Record<string, number> = {
  sm: 16,
  md: 32,
  lg: 48,
  xl: 64,
};

export function Logo({ size = 'md' }: LogoProps) {
  const px = sizeMap[size];
  const isSmall = size === 'sm';

  return (
    <svg
      width={px}
      height={px}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Airgent logomark"
    >
      {isSmall ? (
        // Thicker rects for legibility at 16px
        <>
          <rect x="22" y="12" width="20" height="10" rx={4} fill="currentColor" />
          <rect x="16" y="27" width="32" height="10" rx={4} fill="currentColor" opacity={0.7} />
          <rect x="10" y="42" width="44" height="10" rx={4} fill="currentColor" opacity={0.4} />
        </>
      ) : (
        <>
          <rect x="22" y="14" width="20" height="8" rx={3} fill="currentColor" />
          <rect x="16" y="28" width="32" height="8" rx={3} fill="currentColor" opacity={0.7} />
          <rect x="10" y="42" width="44" height="8" rx={3} fill="currentColor" opacity={0.4} />
        </>
      )}
    </svg>
  );
}
